(function($) {
  "use strict";

  var decodeHtmlEntity = function(str) {
    return str.replace(/&#(\d+);/g, function(match, dec) {
      return String.fromCharCode(dec);
    });
  };

  var isMarketingEnabled = function(status) {
    var marketingCookies = false;
    if (typeof status.categories !== 'undefined') {
      status.categories.forEach( function(item) {
        if (item.id == 'marketing' && item.value == true) {
          marketingCookies = true;
        }
      })
    }

    return marketingCookies;
  }

  var triggerIframeReload = function(status) {
    $(document.querySelectorAll('div.iframe-placeholder')).each(function(i, iframe) {
      var vars = JSON.parse(iframe.dataset.iframeInfo);
      var addedEl = false;
      var d = iframe.previousElementSibling;

      if (isMarketingEnabled(status)){
        if (!d || d.tagName !== 'IFRAME'){
          d = document.createElement('iframe');
          addedEl = true;
          Object.keys(vars).forEach( function(key) {
            d.setAttribute(key, vars[key])
          })
        }
      }

      if (addedEl) {
        iframe.parentNode.insertBefore(d, iframe)
      }
      else {
        d.style.display = isMarketingEnabled(status) ? '' : 'none';
      }

      iframe.style.display = isMarketingEnabled(status) ? 'none' : '';
    })
  }

  window.trestonCookie = {
    onInitialise: function (status) {
      triggerIframeReload(status)
    },
    onStatusChange: function(status, previousStatus) {
      triggerIframeReload(status)
    }
  }

})(jQuery);
